
    import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path.js';
    setBasePath('https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.16.0/cdn/');
  